import gql from 'graphql-tag';

import ItemFragment from './fragments/item';

export default gql`
  query allItems($where: ItemFilter) {
    allItems(where: $where) {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: _LANG_Raw
        }
      }
    }
  }
  ${ItemFragment}
`;
